import { render, staticRenderFns } from "./nav-investment-entity-list.vue?vue&type=template&id=25ea35c3&"
import script from "./nav-investment-entity-list.vue?vue&type=script&lang=ts&"
export * from "./nav-investment-entity-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports